import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { EndpointsAdmin } from '@/admin/services/_endpoints.admin'
import axios from 'axios'
import { AnnouncementDto } from '@/models/dtos/announcementDto'
import { PaginationHelper } from '@/helpers/paginationHelper'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'

export abstract class AnnouncementAdminService {
  static async get(id: string): Promise<AnnouncementDto> {
    const result = await axios
      .get<BaseResponseDto<AnnouncementDto>>(EndpointsAdmin.announcement.get, {
        params: {
          id
        }
      })

    if (!result?.data?.dto) throw new Error('Cannot get announcement')

    return result.data.dto
  }

  static async getAll(currentPage?: number, pageSize?: number): Promise<PagedResponseDto<AnnouncementDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const result = await axios
      .get<BaseResponseDto<PagedResponseDto<AnnouncementDto>>>(EndpointsAdmin.announcement.getAll,
        {
          params: {
            ...pagination
          }
        })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }

  static async add(announcement: AnnouncementDto): Promise<string> {
    const result = await axios
      .post<BaseResponseDto<string>>(EndpointsAdmin.announcement.add, announcement)

    return result.data.dto!
  }

  static async edit(announcement: AnnouncementDto): Promise<void> {
    await axios
      .put<BaseResponseDto<any>>(EndpointsAdmin.announcement.edit, announcement)
  }

  static async remove(id: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(EndpointsAdmin.announcement.remove, {
        params: {
          id
        }
      })
  }
}
